<template>
  <div class="ex-item">
    <div v-if="exLoading" style="text-align:center;line-height:500px;">加载中...</div>
    <div class="ex-item-wrap" @click="goDetails(item)" v-if="exList && !exLoading && exList.length > 0"
      v-for="(item, index) in exList" :key="'ex-wrap-' + index">
      <div class="wrap-t">
        <img v-if="item.logo" :src="item.logo" />
        <img src="@assets/img/empty.png" v-else>
        <p v-if="item.name">{{ item.name }}</p>
        <div class="wrap-t-line"></div>
        <div class="wrap-t-imgbox" v-if="item.listProduct && item.listProduct.length > 0">
          <img v-for="(itm, idx) in item.listProduct" :key="idx" v-if="itm.banner[0] && idx < 3" :src="itm.banner[0]" />
        </div>
      </div>
      <div class="wrap-b">
        <div>
          <i class="icon iconfont icon-dizhi" v-if="item.province || item.city"></i>
          <span v-if="item.province">{{ item.province }}</span>
          &nbsp;<span v-if="item.city">·</span>
          &nbsp;<span v-if="item.city">{{ item.city }}</span>
        </div>
        <!-- <i style="color:#b1262d;" class="icon iconfont icon-love"></i> -->
        <i style="color:#b1262d;" class="icon iconfont icon-love" @click.stop="cancelCollect(item)"
          v-if="item.isFollow"></i>
        <i style="color:#bfbfbf;" class="icon iconfont icon-guanzhu-xian" @click.stop="addCollect(item)" v-else></i>
      </div>
    </div>
    <div v-if="!exLoading && exList && exList.length == 0" style="line-height:500px;text-align:center;">
      暂无数据
    </div>
    <div class="m-page" v-if="totalCount > pageSize">
      <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount"
        @on-change="changePage" @on-page-size-change="changePageSize" show-sizer />
    </div>

    <gLogin :show="show" @close="show = false;" />
  </div>
</template>

<script>
import gLogin from "@components/gLogin/gLogin.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "ex-item",
  props: {
    exList: {
      type: Array,
      default: []
    },
    pageIndex: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    totalCount: {
      type: Number,
      default: 0
    },
    exLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
    };
  },
  components: {
    gLogin
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibiton: "loginModule/getExhibition"
    }),
    opt() {
      return {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        totalCount: this.totalCount
      }
    },
  },
  methods: {
    changePage(e) {

      this.opt.pageIndex = e;
      this.$emit("getExList", this.opt);
    },
    changePageSize(e) {
      this.opt.pageSize = e;
      this.$emit("getExList", this.opt);
    },
    goDetails(item) {
      const url = location.origin + `/ex-details/${item.joinId}?compId=${item.compId}&exhibitionId=${item.exhibitionId}`;
      window.open(url, "_blank");
      // this.$router.push(`/ex-details/${item.joinId}?compId=${item.compId}`);
    },
    addCollect(item) {
      if (!this.user) {
        this.show = true;
        this.$Message.warning("请登录后关注");
        return;
      }
      let body = {
        "userId": this.user.userId,
        "compId": item.compId,
      }
      this.$http.post('/api/Follower', body, this.$store.state.header)
        .then(res => {
          if (res.status === 200 && res.data.successed) {
            this.$emit('addsuccess', item)
          } else {
            this.$Message.error("关注失败，请重新尝试");
          }
        })
    },
    cancelCollect(item) {
      if (!this.user) {
        this.$Message.warning("请登录后操作");
        this.show = true;
        return;
      }
      let body = {
        "userId": this.user.userId,
        "compId": item.compId,
      }
      this.$http.put('/api/Follower/UnFollow', body, this.$store.state.header)
        .then(res => {
          if (res.status === 200 && res.data.successed) {
            this.$emit('cancelsuccess', item)
          } else {
            this.$Message.error("取消失败，请重新尝试");
          }
        })

    }
  }
};
</script>

<style scoped lang='scss'>
.ex-item {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 50px;

  &-wrap {
    width: 100%;
    height: 150px;
    padding-top: 20px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      transform: scale(1.1);
    }

    .wrap-t {
      display: flex;
      align-items: center;
      width: 100%;
      height: 87px;
      padding: 0 0 0 20px;

      img {
        width: 74px;
        height: 74px;
        border-radius: 50%;
      }

      p {
        margin: 0 10px 0 10px;
        width: 270px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &-line {
        width: 2px;
        height: 80px;
        background-color: #e6e6e6;
      }

      &-imgbox {
        width: 490px;
        padding-left: 40px;
        display: flex;
        align-items: center;

        img {
          width: 130px;
          height: 87px;
          border-radius: 0;
          margin-right: 20px;
        }
      }
    }

    .wrap-b {
      display: flex;
      justify-content: space-between;
      height: 43px;
      align-items: center;
      padding: 0 20px;

      div {
        color: #333;
        font-size: 12px;
        display: flex;
        align-items: center;
        height: 100%;

        i {
          font-size: 22px;
          color: #999;
        }
      }

      i {
        font-size: 30px;
      }
    }
  }

  .m-page {
    width: 100%;
    padding: 20px 0;
    text-align: center;
  }
}
</style>
<style lang="scss">
.ivu-message {
  z-index: 1050 !important;
}
</style>
